var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ChartBox',{attrs:{"title":"投诉意见反馈"}},[_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.suggestImg}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }